import type {
  AddContractorUserRequest,
  AddContractorUserResult,
  AddContractorUserApiResponse,
} from "@onsemble/shared/types/internal";
import { TanstackError } from "../client";

/**
 * Add a user to a contractor organization
 */
export async function addContractorUser(
  orgId: string,
  data: AddContractorUserRequest
): Promise<AddContractorUserResult> {
  const response = await fetch(`/api/internal/contractors/${orgId}/users`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(data),
  });

  const result: AddContractorUserApiResponse = await response.json();

  if (!response.ok || !result.success) {
    throw new TanstackError(
      response.status,
      result.error || "Failed to add user"
    );
  }

  return result.data;
}
